interface FireIconProps {
  size: number;
  opacity?: number;
}

export function FireIcon({ size, opacity = 1 }: FireIconProps) {
  return (
    <img
      src="/assets/fire-emoji-white-border.png"
      alt=""
      aria-hidden
      className="object-contain"
      style={{ width: size, height: size, opacity }}
    />
  );
}
